import React from "react";

// children = page actions (search, add button…), aligned right of the title
const Header = ({ category, title, children }) => {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
      <div>
        <p className="text-xs font-semibold uppercase tracking-wider text-gray-400">
          {category}
        </p>
        <p className="text-slate-900 dark:text-gray-100 text-2xl font-bold tracking-tight">
          {title}
        </p>
      </div>
      {children && (
        <div className="flex flex-wrap items-center gap-3 w-full sm:w-auto">
          {children}
        </div>
      )}
    </div>
  );
};

export default Header;
